import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip.tsx';
import { cn } from 'cn';
import { ReactNode } from 'react';

type InlineTooltipProps = {
  children: ReactNode;
  message?: string | null;
  triggerClassName?: string;
};

/** Подсказка при наведении; без `message` рендерится только `children` (удобно для disabled-кнопок). */
export function InlineTooltip({ children, message, triggerClassName }: InlineTooltipProps) {
  if (!message) {
    return children;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger
          render={<span className={cn('flex min-w-0', triggerClassName ?? 'w-full')} />}
        >
          {children}
        </TooltipTrigger>
        <TooltipContent side="top">{message}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
